export default __webpack_public_path__ + "71909deb4053a10324af0c6298900076.png";